module.exports = __webpack_public_path__ + "static/media/right-gradient-cover.d62b2675.svg";